export default {
  repliquesTableHeaders: [
    {
      text: 'filialRepliques',
      value: 'filial',
      width: 180,
      filterable: true,
      filterComponent: 'SetFilter',
      isDataTable: true,
      filterParams: {
        filterSet: [
          'TAGLOG SUMARE',
          'TAGLOG ITAJAI',
          'TAGLOG CABO',
        ],
        field: 'filial',
      },
    },
    {
      text: 'CTE',
      value: 'CTE',
      width: 180,
      filterable: true,
      filterComponent: 'TextFilter',
      isDataTable: true,
      filterParams: {
        field: 'cte',
      },
    },
    {
      text: 'status',
      value: 'status',
      width: 240,
      filterable: true,
      filterComponent: 'SetFilter',
      isDataTable: true,
      filterParams: {
        filterSet: [
          'CANCELADO',
          'ENCERRADO',
          'CONCLUIDO',
          'CONFIRMADO',
          'SOLICITAÇAO CANCELAMENTO',
          'PENDENTE',
          'FINALIZADO',
          'ESTORNADO',
        ],
        field: 'status',
      },
    },
    {
      text: 'chaveAcesso',
      value: 'chaveAcesso',
      filterable: true,
      filterComponent: 'TextFilter',
      isDataTable: true,
      filterParams: {
        field: 'chaveAcesso',
      },
    },
    {
      text: 'codigoDocumentoConexos',
      value: 'codigoDocumento',
      width: 180,
      filterable: true,
      filterComponent: 'TextFilter',
      isDataTable: true,
      filterParams: {
        field: 'codigoDocumento',
      },
    },
    {
      text: 'serie',
      value: 'serie',
      width: 180,
      filterable: true,
      filterComponent: 'TextFilter',
      isDataTable: true,
      filterParams: {
        field: 'serie',
      },
    },
    {
      text: 'dataEmissao',
      value: 'dataEmissao',
      width: 180,
      filterable: true,
      filterComponent: 'DateFilter',
      isDataTable: true,
      filterParams: {
        field: 'dataEmissao',
      },
    },
    {
      text: 'pagador',
      value: 'pagador',
      width: 240,
      filterable: true,
      filterComponent: 'TextFilter',
      isDataTable: true,
      filterParams: {
        field: 'pagador',
      },
    },
    {
      text: 'CNPJ',
      value: 'CNPJ',
      width: 260,
      filterable: true,
      filterComponent: 'TextFilter',
      isDataTable: true,
      filterParams: {
        field: 'cnpj',
      },
    },
    {
      text: 'CFOP',
      value: 'CFOP',
      width: 180,
      filterable: true,
      filterComponent: 'TextFilter',
      isDataTable: true,
      filterParams: {
        field: 'cfop',
      },
    },
    {
      text: 'baseICMS',
      value: 'baseICMS',
      width: 180,
      filterable: true,
      filterComponent: 'TextFilter',
      isDataTable: true,
      filterParams: {
        field: 'baseICMS',
      },
    },
    {
      text: 'prcICMS',
      value: 'prcICMS',
      width: 180,
      filterable: true,
      filterComponent: 'TextFilter',
      isDataTable: true,
      filterParams: {
        field: 'prcICMS',
      },
    },
    {
      text: 'ICMS',
      value: 'ICMS',
      width: 180,
      filterable: true,
      filterComponent: 'TextFilter',
      isDataTable: true,
      filterParams: {
        field: 'icms',
      },
    },
    {
      text: 'totalNota',
      value: 'totalNota',
      width: 180,
      filterable: true,
      filterComponent: 'TextFilter',
      isDataTable: true,
      filterParams: {
        field: 'totalNota',
      },
    },
  ],
  repliquesTableItems: [],
  filtros: {
    termo: '',
    page: 1,
    perPage: 20,
    order: '',
    direcao: '',
    visibilidade: 'todos',
  },
};
